import Swal from 'sweetalert2'

const confirmDelete = (id, resource = '', confirmMsg, onConfirm) => {
  Swal.fire({
    title: `Deletar ${resource}.`,
    text: confirmMsg,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#185273',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sim, remover',
    cancelButtonText: 'Cancelar'
  }).then(result => {
    if (result.isConfirmed) {
      onConfirm(id)
    }
  })
}

export { confirmDelete }
